module.exports = __webpack_public_path__ + "static/media/withdrawal_ya_pressed.4dad5975.svg";